import EventEmitter from 'events';

const hasNewVideoInterruption = (prevStats, currentStats) =>
  typeof prevStats?.video?.pauseCount === 'number' &&
  typeof currentStats.video?.pauseCount === 'number' &&
  prevStats.video.pauseCount < currentStats.video.pauseCount;

const hasCodecChanged = (prevStats, currentStats) =>
  prevStats?.video?.codec &&
  currentStats?.video?.codec &&
  prevStats.video.codec !== currentStats.video.codec;

const hasResolutionChanged = (prevStats, currentStats) =>
  prevStats?.video?.width &&
  prevStats.video.height &&
  (prevStats.video.width !== currentStats.video?.width ||
  prevStats.video.height !== currentStats.video?.height);

const createSubscriberVideoQualityWatcher = (getPcStats, interval = 1000) => {
  const ee = new EventEmitter();
  let lastStats;

  const processStats = (stats) => {
    const prevLastStats = lastStats;
    lastStats = stats;

    if (hasNewVideoInterruption(prevLastStats, stats)) {
      ee.emit('videoQualityChanged', {
        reason: 'videoInterruption',
        stats,
      });
      return;
    }

    if (hasCodecChanged(prevLastStats, stats)) {
      ee.emit('videoQualityChanged', {
        reason: 'codecChange',
        stats,
      });
      return;
    }

    if (hasResolutionChanged(prevLastStats, stats)) {
      ee.emit('videoQualityChanged', {
        reason: 'resolutionChange',
        stats,
      });
    }
  };

  const getStats = () => {
    getPcStats((err, stats) => {
      if (!err) {
        processStats(stats);
      }
    });
  };

  let cancelId;
  return Object.assign(ee, {
    start() {
      if (cancelId) {
        // already started
        return;
      }
      cancelId = setInterval(() => {
        getStats();
      }, interval);
    },

    stop() {
      clearInterval(cancelId);
      cancelId = undefined;
      lastStats = undefined;
    },

    destroy() {
      this.stop();
      ee.removeAllListeners();
    },
  });
};

export default createSubscriberVideoQualityWatcher;
